if (typeof JW === 'undefined') JW = {};
JW.SiocLive = (function ($)
{
    var State = JW.State;

    var _pri = {};
    var publ = {};

    publ.SS_MAX_SIZE = 1024 * 1024 * 8;
    publ.MSG_MAX_LEN = 512;

    publ.VISIBLE     = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.cname    = 'SIOC';
    _pri.opts = {
        dbg_lvl: 1
    };

    _pri.nsp_type       = 'live';
    _pri.nsp_name       = '';
    _pri.sio_path       = '/sio';
    _pri.socket         = null;
    _pri.conn_state     = -1;       // tri state -1 0 1
    _pri.auth_state       = State.STATE_ERR_NO_INIT;
    _pri.admin_room_ids = [];
    _pri.tdiff          = 0;
    _pri.rx_room_id     = /^live(?:0|[1-9][0-9]{0,9})$/;
    _pri.room_id_pre    = 'live';

    _pri.$win_ss          = null;
    _pri.win_id           = '';
    _pri.$wrp_ss_inp_file = null;

    _pri.uid     = '';
    _pri.inited  = false;
    _pri.page    = null;
    _pri.$xch    = null;
    _pri.asnd    = null;
    _pri.tpls    = {};

    _pri.rooms_map  = {};
    _pri.states_map = null;


    publ.init = function()
    {
        if (_pri.inited)
        {
            _pri.dbgR('!!! already inited!');
            return;
        }
        _pri.inited = true;

        _pri.dbgG('*** init()', _pri.cname);
        _pri.dbg('    opts.env_int:', _pri.opts.env_int);

        if (_pri.opts.env_int)
        {
            _pri.opts.sio_ipaddr = '192.168.0.110';
            _pri.opts.sio_host   = 'sio.int.jobwoche.de';
            _pri.opts.sio_port   = 443;
        }
        else
        {
            _pri.opts.sio_ipaddr = '87.118.123.16';
            _pri.opts.sio_host   = 'sio.jobwoche.de';
            _pri.opts.sio_port   = 443;
        }

        _pri.rooms_inited     = false;
        _pri.socket_inited    = false;
        _pri.$doc             = $(document);
        _pri.page             = JW.Page;
        _pri.uid              = JW.Page.getUId(32);
        _pri.$xch             = $('#xch');
        _pri.$wrp_sioc        = $('#wrp_sioc');
        _pri.$wrp_ss_inp_file = $('#wrp_ss_inp_file');
        _pri.eid              = _pri.$wrp_sioc.data('eid');

        if (_pri.$wrp_sioc.length != 1)
        {
            _pri.dbg('--- missing #wrp_sioc - return.');
            return;
        }
        else if (_pri.$wrp_sioc.data('nsp_type') !== _pri.nsp_type)
        {
            _pri.dbg('--- different nsp_type - return.');
            return;
        }

        _pri.nsp_name = _pri.$wrp_sioc.data('nsp');
        if (typeof _pri.nsp_name !== 'string' || _pri.nsp_name.length < 3)
        {
            _pri.dbgR('!!! missing data-nsp! - return.');
            return;
        }
        else
        {
            _pri.dbgY('*** setting nsp_name to:', _pri.nsp_name);
        }

        _pri.cname += _pri.nsp_name.toUpperCase();
        _pri.asnd = new Audio('/img/snd/s11.mp3'); // document.getElementById('a0_snd');
        // _pri.asnd = new Audio('/img/snd/s001.mp3'); // document.getElementById('a0_snd');
        // _pri.asnd.loop = true;

        _pri.meta = {
            state: State.STATE_OK
        };

        _pri.initTpls('#wrp_tpls');
        _pri.setErrMsgs();
        _pri.initEvs();

        // if (_pri.page.isLoggedIn())
        // {
        //     _pri.initSocket();
        // }
        _pri.initSocket();

        // _pri.connect();
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    publ.getEId = function()
    {
        return _pri.eid;
    };

    publ.getCid = function()
    {
        return _pri.uid;
    };

    publ.getRoomIdByLcId = function(lc_id)
    {
        return _pri.room_id_pre + lc_id;
    };

    publ.getLcIdByRoomId = function(room_id)
    {
        return room_id.substr(4);
    };

    publ.getSUTS = function()
    {
        return (Math.floor(Date.now() / 1000) + _pri.tdiff);
    };

    publ.getMeta = function()
    {
        var o = {
            suts_from: publ.getSUTS()
        };
        return $.extend(o, _pri.meta);
    };

    publ.isLoggedIn = function()
    {
        _pri.dbg('*** isLoggedIn()');

        if (_pri.conn_state == 1 && _pri.socket.display_name != '')
        {
            return true;
        }

        return false;
    };

    publ.getAuthState = function()
    {
        return _pri.auth_state;
    };

    publ.isAdmForRoomId = function(room_id)
    {
        _pri.dbg('*** isAdmForRoomId() - _pri.admin_room_ids:', _pri.admin_room_ids, 'room_id:', room_id);

        if (typeof room_id !== 'string')
        {
            room_id = '';
        }

        return (room_id != '' && _pri.admin_room_ids.indexOf(room_id) != -1);
    };

    publ.validateDisplayName = function(str)
    {
        // quite permissive, but whereby accepts that too

        // _pri.dbgR('*** validateDisplayName()');

        // return (/^[^\p{C}\p{Z}](?:[^\p{C}\p{Z}]| ){2,28}[^\p{C}\p{Z}]$/u.test(str));
        // return !(/( )\1+/u.test(str));

        return (/^[^<>'"&]{3,30}$/u.test(str) && /^[^\p{C}\p{Z}](?:[^\p{C}\p{Z}]| ){1,28}[^\p{C}\p{Z}]$/u.test(str) && !(/( )\1+/u.test(str)));
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    publ.joinRoom = function(meta)
    {
        _pri.dbg('*** joinRoom() meta:', meta);
        _pri.addRoom(meta);
    };

    publ.leaveRoom = function(room_id)
    {
        _pri.dbg('*** leaveRoom() room_id', room_id);
        if (typeof _pri.rooms_map[room_id] !== 'undefined')
        {
            _pri.rooms_map[room_id].deleteRoom();
            delete _pri.rooms_map[room_id];
            // $('#sio_chat_room_' + room_id).remove();
        }
    };

    publ.leaveAll = function()
    {
        _pri.dbg('*** leaveAll()');
        $.each(_pri.rooms_map, function(k, v) {
            _pri.dbg('    k:', k);
            if (k != 'live0' && typeof _pri.rooms_map[k] !== 'undefined')
            {
                _pri.rooms_map[k].deleteRoom();
                delete _pri.rooms_map[k];
                // $('#sio_chat_room_' + k).remove();
            }
        });
    };

    // no knock, so check before enter ...
    publ.checkRoomAdm = function(meta, cb)
    {
        _pri.dbg('<-- checkRoomAdm() meta:', meta);

        if (meta.state == State.STATE_OK)
        {
            if (!publ.isValidConn())
            {
                meta.state = State.STATE_ERR_CONN;
            }
        }

        if (meta.state == State.STATE_OK)
        {
            if (publ.getAuthState() != State.STATE_OK)
            {
                meta.state = State.STATE_ERR_AUTH;
            }
        }

        if (meta.state == State.STATE_OK)
        {
            if (!publ.isAdmForRoomId(meta.room_id_to))
            {
                meta.state = State.STATE_ERR_ROOM_ADM;
            }
        }

        if (meta.state == State.STATE_OK)
        {
            _pri.socket.emit('check_room_adm', meta, cb);
        }
        else
        {
            cb(meta);
        }
    };

    publ.getRoomStatus = function(room_id, cb)
    {
        _pri.dbg('<<< getRoomStatus() room_id:', room_id);

        if (publ.isValidConn())
        {
            _pri.socket.emit('room_status', room_id, function(ret) {

                _pri.dbg('>>> getRoomStatus', ret);
            });
        }
    };

    publ.getRoomState = function(meta, cb)
    {
        _pri.dbg('<<< getRoomState() meta:', meta);

        if (publ.isValidConn())
        {
            _pri.socket.emit('get_room_state', meta, cb);
        }
        else
        {
            setTimeout(function() {
                publ.getRoomState(meta, cb);
            }, 500);
        }
    };

    publ.knock = function(meta, cb)
    {
        _pri.dbg('<-- knock() meta', meta);

        if (publ.isValidConn())
        {
            _pri.dbg('    ok, valid conn ...');
            _pri.socket.emit('knock', meta, cb);
        }
    };

    publ.addWaiting = function(room_id, cb)
    {
        _pri.dbg('<-- addWaiting() room_id:', room_id);

        if (publ.isValidConn())
        {
            _pri.dbg('    ok, valid conn ...');
            _pri.socket.emit('add_waiting', room_id, function(ret) {

                _pri.dbg('--> addWaiting', ret);
                if (typeof cb === 'function')
                {
                    cb(ret);
                }
            });
        }
    };

    publ.getUserListMenu = function(room_id)
    {
        _pri.dbg('*** getUserListMenu() room_id', room_id);

        var list = '';
        if (typeof _pri.rooms_map[room_id] !== 'undefined')
        {
            $.each(_pri.rooms_map[room_id].socket_ids_map, function(k, v) {
                if (k == _pri.socket.id)
                {
                    list += '<a class="dropdown-item text-muted nosel" href="">' + _pri.encodeHTML(v) + '</a>';
                }
                else
                {
                    list += '<a class="dropdown-item dd_user cup" href="" data-unm="' + v + '" data-sid="' + k + '">' + _pri.encodeHTML(v) + '</a>';
                }
            });
        }

        return list;
    };

    publ.setRoomBusy = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('set_room_locked', meta, cb);
        }
    };

    publ.getWaitingsList = function(room_id, cb)
    {
        _pri.dbg('<-- getWaitingsList() room_id:', room_id);

        if (publ.isValidConn())
        {
            _pri.dbg('    ok, valid conn ...');
            _pri.socket.emit('get_waitings_list', room_id, cb);
        }
    };

    publ.kickUser = function(meta)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('kick_user', meta);
        }
    };

    publ.inviteUser = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('invite_user', meta, cb);
        }
    };

    publ.hasValidStatesMap = function functionName()
    {
        return _pri.isObj(_pri.states_map);
    };

    publ.getStatesMap = function()
    {
        _pri.dbgG('*** getStatesMap()', publ.isValidConn(), publ.isConn());
        // if (publ.isValidConn())
        // {
        //     _pri.dbg('    emit get_states_map ...');
        //     _pri.socket.emit('get_states_map', {state: State.STATE_OK}, _pri.onStatesMap);
        // }
        return _pri.states_map;
    };

    publ.validRoomId = function(room_id)
    {
        // live0
        if (typeof room_id !== 'string' || room_id.length < 5 || room_id.length > 14 || !_pri.rx_room_id.test(room_id))
        {
            return false;
        }

        return true;
    };

    publ.onErr = function(meta)
    {
        _pri.dbgR('### onErr() socket.id:', _pri.socket.id, 'conn_state: [' + _pri.conn_state + ']', 'meta:', meta);

        if (meta.state == State.STATE_ERR_ROOM_JOIN)
        {
            JW.Live.onRoomJoinErr(meta);
        }
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    publ.admNsps = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('adm_nsps', meta, cb);
        }
    }

    publ.admStats = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('adm_stats', meta, cb);
        }
    }

    publ.admTests = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('adm_tests', meta, cb);
        }
    }

    publ.admLobbyMsg = function(meta, cb)
    {
        if (publ.isValidConn())
        {
            _pri.socket.emit('adm_lobbymsg', meta, cb);
        }
    }

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.initSocket = function()
    {
        _pri.dbgG('*** _pri.initSocket()');

        if (!_pri.socket_inited)
        {
            _pri.socket_inited = true;

            // var c_str = document.cookie;
            // _pri.dbg('    cookie str:', c_str);
            // var c_val = _pri.getCookieVal('SSSID');
            // _pri.dbg('    c_val:', c_val);

            _pri.socket = io('https://' + _pri.opts.sio_host + ':' + _pri.opts.sio_port + _pri.nsp_name, {
                path:            _pri.sio_path,
                secure:          true,
                autoConnect:     true,
                // transports: [ 'websocket' ], // because we'll only support current browsers anyway ... will we ...?
                transports: ['websocket'],
                rememberUpgrade: true,
                query:           {
                    cid: _pri.uid,
                    eid: _pri.eid
                }
            });

            _pri.socket.on('connect',           _pri.onConnect);
            _pri.socket.on('auth',              _pri.onAuth);
            _pri.socket.on('disconnect',        _pri.onDisconnect);
            _pri.socket.on('nsp_stop',          _pri.onNspStop);
            _pri.socket.on('user_joined',       _pri.onUserJoined);
            _pri.socket.on('user_left',         _pri.onUserLeft);
            _pri.socket.on('knock',             _pri.onKnock);
            _pri.socket.on('knock_noroom',      _pri.onKnockNoroom);
            _pri.socket.on('kick_user',         _pri.onKickUser);
            _pri.socket.on('invite_user',       _pri.onInviteUser);
            _pri.socket.on('lobby_msg',         _pri.onLobbyMsg);
            _pri.socket.on('states_map',        _pri.onStatesMap);

            _pri.socket.on('error',             _pri.onError);
            _pri.socket.on('connect_error',     _pri.onError);
            _pri.socket.on('reconnect_error',   _pri.onError);

            _pri.socket.on('reconnect_attempt', _pri.onReconnAttempt);
            _pri.socket.on('reconnecting',      _pri.onReconnecting);

            ss(_pri.socket).on('ss_file',       _pri.onSsFile);
            ss(_pri.socket).on('error', function(err) {
                _pri.dbg('*** ss(socket) on error - err:', err);
            });

            ss(_pri.socket).on('close', function(e) {
                _pri.dbg('*** ss(socket) on close - e:', e);
            });
        }
    };

    _pri.onConnect = function()
    {
        _pri.dbg('### onConnect() socket.id:', _pri.socket.id, 'conn_state: [' + _pri.conn_state + ']');
        _pri.socket.display_name = '';

        if (!_pri.rooms_inited)
        {
            _pri.initRooms();
        }

        _pri.dbg('    setting conn_state to 1');
        _pri.conn_state = 1;
        _pri.page.trigger('sio:on_connect', {});
    };

    _pri.onAuth = function(meta)
    {
        _pri.dbgG('### onAuth() socket.id:', _pri.socket.id, 'conn_state: [' + _pri.conn_state + ']', 'meta:', meta);

        _pri.auth_state = meta.state;
        if (meta.state === State.STATE_OK)
        {
            _pri.dbg('    socket.display_name:', _pri.socket.display_name);

            if (typeof meta.admin_room_ids !== 'object' || !$.isArray(meta.admin_room_ids))
            {
                meta.admin_room_ids = [];
            }

            _pri.meta.display_name_from = meta.display_name;
            _pri.admin_room_ids         = meta.admin_room_ids;
            _pri.tdiff                  = Math.floor(Date.now() / 1000) - meta.suts;
            _pri.socket.display_name    = meta.display_name;
            _pri.page.trigger('sio:on_auth', meta);

            _pri.dbgR('    meta.sutc:', meta.suts);
            _pri.dbgR('    tdiff:', _pri.tdiff);
            _pri.dbgR('    Date.now():', Date.now());

            if (!_pri.isObj(_pri.states_map))
            {
                _pri.socket.emit('get_states_map', {state: State.STATE_OK}, _pri.onStatesMap);
            }
        }
        else
        {
            _pri.dbg('    !!! err:' + meta.err_msgs);
            // JW.Modal.showMsg(meta.err_msgs);
        }
    };

    _pri.onDisconnect = function()
    {
        _pri.dbg('### onDisconnect socket.id:', _pri.socket.id, 'conn_state: [' + _pri.conn_state + ']');

        _pri.dbg('    setting conn_state to -1');
        _pri.conn_state = -1;
        _pri.admin_room_ids = [];

        _pri.page.trigger('sio:on_disconnect', {display_name: _pri.socket.display_name});
        _pri.socket.display_name = '';
    };

    _pri.onNspStop = function(meta)
    {
        _pri.dbgR('### on nsp_stop', meta);
        window.location.href = '/';
    };

    _pri.onUserJoined = function(meta)
    {
        // _pri.dbg('### on user_joined', meta);
        var room = _pri.getRoomByMeta(meta);
        if (room != null)
        {
            room.onUserJoined(meta);
        }
    };

    _pri.onUserLeft = function(meta)
    {
        // _pri.dbg('### on user_left', meta);
        var room = _pri.getRoomByMeta(meta);
        if (room != null)
        {
            // _pri.dbg('    room:', room);
            room.onUserLeft(meta);
        }
    };

    _pri.onKnock = function(meta, ack)
    {
        _pri.dbg('*** onKnock() meta:', meta, 'ack:', ack);

        if (typeof ack !== 'function')
        {
            _pri.dbgR('    !!! ack is not a function!');
            ack = function() {};
        }

        // check, if we really are in that room ...
        // var room = _pri.getRoomByMeta(meta);

        var $wrp_chat = $('#wrp_chat');
        if (!$wrp_chat.data('admin'))
        {
            _pri.dbgR('    !!!!!!!! no admin???');
            return;
        }

        if ($wrp_chat.length == 1)
        {
            var msg = '&laquo;' + _pri.encodeHTML(meta.display_name_from) + '&raquo; möchte den Raum betreten.';
            var tpl = publ.getTpl('sio_knock_msg');
            var win = tpl.replace(/\{MSG\}/g, msg);

            var $win = $(win).attr('id', 'sio_knock_msg_' + _pri.page.getUId());
            $win.find('.sio-ok').on('click', function() {
                meta.state = State.STATE_OK;
                ack(meta);
                $win.remove();
            });
            $win.find('.sio-busy').on('click', function() {
                meta.state = State.STATE_BUSY;
                ack(meta);
                $win.remove();
            });

            $wrp_chat.append($win);
            _pri.asnd.play();
        }
        else
        {
            _pri.dbgY('    ??? am i admin but not in my room anymore? ...');

            meta.state = State.STATE_ERR;
            ack(meta);
        }
    };

    _pri.onKnockNoroom = function(meta, ack)
    {
        _pri.dbg('>>> onKnockNoroom() meta:', meta, 'ack:', ack);
        if (typeof ack === 'function')
        {
            if (!JW.Modal.hasMask())
            {
                JW.Modal.setMask(1, 1, 0);

                var tpl_id = 'sio_knock_noroom';
                var tpl = publ.getTpl(tpl_id);
                tpl_id += _pri.page.getUId();

                var cmp_name = '';
                if (typeof meta.cmp_name_to !== 'undefined' && meta.cmp_name_to != '')
                {
                    cmp_name = '&laquo;' + meta.cmp_name_to + '&raquo;';
                }
                var win = tpl.replace(/\{USER_NAME\}/g, '&laquo;' + _pri.encodeHTML(meta.display_name_from) + '&raquo;').replace(/\{CMP_NAME\}/g, cmp_name);
                var msg = '';

                var $win = $(win).attr('id', tpl_id);
                $win.find('.sio-ok').on('click', function() {
                    meta.admin_msg = $win.find('#admin-msg').val();
                    meta.state = State.STATE_BUSY; // State.STATE_INFO;
                    ack(meta);
                    JW.Modal.closeWinAnim(tpl_id, function() {
                        JW.Modal.setMask(0, 0, 0);
                    });
                });
                $win.find('.sio-ok-room').on('click', function() {
                    meta.admin_msg = $win.find('#admin-msg').val();
                    meta.state = State.STATE_TRY_AGAIN;
                    JW.Modal.closeWinAnim(tpl_id, function() {
                        JW.Modal.setMask(0, 0, 0);
                        JW.Live.goToAdminRoom(meta.room_id_to, true);
                        ack(meta);
                    });
                });

                var promise = _pri.asnd.play();
                if (promise !== undefined) {
                    promise.then(function(_) {
                        // Autoplay started!
                    }).catch(function(error) {
                        // Autoplay was prevented.
                        // Show a "Play" button so that user can start playback.
                    });
                }

                // _pri.asnd.play();

                JW.Modal.showMsgWin($win, tpl_id);
            }
            else
            {
                meta.state = State.STATE_BUSY;
                ack(meta);
            }
        }
        else
        {
            _pri.dbgR('    !!! ack is not a function!');
        }
    };

    _pri.onKickUser = function(meta)
    {
        JW.Live.onKickUser(meta);
    };

    _pri.onInviteUser = function(meta, ack)
    {
        _pri.dbg('>>> onInviteUser() meta:', meta, 'ack:', ack);

        if (typeof ack === 'function')
        {
            if (!JW.Modal.hasMask())
            {
                JW.Modal.setMask(1, 1, 0);

                var tpl_id = 'sio_invite_user';
                var tpl = publ.getTpl(tpl_id);
                tpl_id += _pri.page.getUId();

                var win = tpl.replace(/\{CMP_NAME\}/g, meta.cmp_name);

                var $win = $(win).attr('id', tpl_id);
                $win.find('.sio-no').on('click', function() {
                    meta.state = State.STATE_REJECT;
                    ack(meta);
                    JW.Modal.closeWinAnim(tpl_id, function() {
                        JW.Modal.setMask(0, 0, 0);
                    });
                });
                $win.find('.sio-ok').on('click', function() {
                    meta.state = State.STATE_OK;
                    ack(meta);
                    JW.Modal.closeWinAnim(tpl_id, function() {
                        JW.Modal.setMask(0, 0, 0);
                        JW.Live.enterRoom(meta);
                    });
                });

                var promise = _pri.asnd.play();
                if (promise !== undefined) {
                    promise.then(function(_) {
                        // Autoplay started!
                    }).catch(function(error) {
                        // Autoplay was prevented.
                        // Show a "Play" button so that user can start playback.
                    });
                }

                // _pri.asnd.play();

                JW.Modal.showMsgWin($win, tpl_id);
            }
            else
            {
                // a dialog is already or still open ...
                meta.state = State.STATE_NONE;
                ack(meta);
            }
        }
        else
        {
            _pri.dbgR('    !!! ack is not a function!');
        }
    };

    _pri.onLobbyMsg = function(meta)
    {
        _pri.dbg('*** onLobbyMsg() isConn?:', publ.isConn());
        if (publ.isConn())
        {
            _pri.page.trigger('sio:on_lobby_msg', meta);
        }
    };

    _pri.onStatesMap = function(meta)
    {
        _pri.dbg('*** onStatesMap() isConn?:', publ.isConn());
        if (publ.isConn() && _pri.isObj(meta))
        {
            _pri.states_map = meta.states_map;
            _pri.page.trigger('sio:on_states_map', meta);
        }
    };

    _pri.onReconnAttempt = function(no)
    {
        _pri.dbgG('*** onReconnAttempt() no:', no, 'isConn?:', publ.isConn());

        _pri.conn_state = 0;
        _pri.dbg('    conn_state set to 0, no:', no);
        if (publ.isConn())
        {
            _pri.log('    !!! isConn is TRUE!');
        }

        _pri.dbg('    set transports to [polling, websocket]');
        _pri.socket.io.opts.transports = ['polling', 'websocket'];
    };

    _pri.onReconnecting = function(no)
    {
        _pri.conn_state = 0;
        _pri.dbg('*** onReconnecting() conn_state set to 0, no:', no);
        if (publ.isConn())
        {
            _pri.log('    !!! isConn is TRUE!');
        }
    };

    _pri.onError = function(err)
    {
        _pri.dbg('!!! onError() err:', err);
    };

    _pri.connect = function()
    {
        if (_pri.socket_inited)
        {
            if (publ.isDisc())
            {
                _pri.dbg('*** _pri.connect() setting conn_state to 0');
                _pri.conn_state = 0;
                _pri.socket.open();
            }
        }
        else
        {
            _pri.dbg('*** _pri.connect() setting conn_state to 0');
            _pri.conn_state = 0;
            _pri.initSocket();
        }
    };

    _pri.disconnect = function()
    {
        if (publ.isConn())
        {
            _pri.dbg('*** _pri.disconnect() socket.id: [' + _pri.socket.id + '] setting conn_state to 0');
            _pri.conn_state = 0;
            // sometimes servers on disconnect/disconnecting isn't fired ...
            // _pri.socket.close();
            _pri.socket.emit('do_disconnect', {
                socket_id: _pri.socket.id
            });
        }
    };

    publ.isConn = function()
    {
        // return (_pri.socket != null && _pri.socket.connected);
        return (_pri.socket != null && _pri.conn_state === 1);
    };

    publ.isDisc = function()
    {
        // return (_pri.socket != null && _pri.socket.connected);
        return (_pri.socket != null && _pri.conn_state === -1);
    };

    publ.isValidConn = function()
    {
        // _pri.dbg('*** isValidConn()');
        if (_pri.socket != null)
        {
            _pri.dbg('*** isValidConn() socket != null, connected:', _pri.socket.connected, 'user_name:', _pri.socket.display_name, 'conn_state: [' + _pri.conn_state + ']');
        }
        else
        {
            _pri.dbg('*** isValidConn() socket == null');
        }
        return (publ.isConn() && _pri.socket.display_name != '');
    };

    publ.getNspName = function()
    {
        return _pri.nsp_name;
    };

    _pri.onSsFile = function(stream_r, meta)
    {
        _pri.dbg('### on ss_file');

        // var bin_str = "";
        //
        // stream_r.on('data', function(data) {
        //     for (var i = 0; i < data.length; i++)
        //     {
        //         bin_str += String.fromCharCode(data[i]);
        //     }
        // });
        //
        // stream_r.on('end', function(data) {
        //     _pri.dbg(bin_str);
        //     // var obj_url = URL.createObjectURL(bin_str); // err: Uncaught TypeError: Failed to execute 'createObjectURL' on 'URL': No function was found that matched the signature provided.
        //     // try: var blob new Blob([bin_str], { type : "octet/stream" }); var obj_url = URL.createObjectURL(blob);
        //     bin_str = '';
        //     _pri.dbg(obj_url);
        // });

        file_buf = [],
        file_len = 0;

        stream_r.on('data', function(chunk) {

            file_len += chunk.length;
            var progress = Math.floor((file_len / meta.size) * 100);
            progress = Math.max(progress - 2, 1);
            _pri.dbg('    ### on data - progress:', progress);
            file_buf.push(chunk);
        });

        stream_r.on('end', function() {

            _pri.dbg('    ### on end');

            var file_arr = new Uint8Array(file_len),
            i = 0;

            // loop to fill the final array
            file_buf.forEach(function (buff) {
                for (var j = 0; j < buff.length; j++) {
                    file_arr[i] = buff[j];
                    i++;
                }
            });

            var blob = new Blob([file_arr], {
                type : 'octet/stream'
            });

            _pri.dbg('    blob:', blob);

            var url = window.URL.createObjectURL(blob);
            _pri.dbg(url);

            var a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = url;
            a.download = meta.name;
            a.click();
            // below doesn't work for iOS Safari ... but without - no problems so far, even in chrome on linux ...
            // window.URL.revokeObjectURL(url); // release objecturl - https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications
        });

        stream_r.on('close', function() {
            _pri.dbg('    ### stream_r on close');
        });

        stream_r.on('error', function(err) {
            _pri.dbg('    ### stream_r on error - err:', err);
        });

        stream_r.on('unpipe', function(e) {
            _pri.dbg('    ### stream_r on unpipe - e:', e);
        });
    };

    _pri.onSSInpFileChange = function(e)
    {
        var $this   = $(this);
        var room_id = $this.data('room_id');
        var file_id = $this.data('file_id');
        var $lbl    = $('#ss_file_lbl_' + file_id);
        var $btn    = $('#ss_btn_send_' + file_id);

        _pri.dbg('*** onSSInpFileChange() room_id: [' + room_id + '] ...');

        if ($this.val() != '')
        {
            $lbl.text(e.target.files[0].name);
            $lbl.attr('title', e.target.files[0].name);
            $btn.removeClass('op03');
            $btn.prop('disabled', false);
        }
        else
        {
            $lbl.text('Datei auswählen ...');
            $btn.prop('disabled', true);
            $btn.addClass('op03');
        }
    };

    _pri.cbSsFile = function(resp, meta)
    {
        _pri.dbg('*** cbSsFile()');
        _pri.dbg('    resp:', resp);
        _pri.dbg('    meta:', meta);
        if (typeof resp === 'object' && resp.state !== State.STATE_OK)
        {
            var err_msg = publ.getErrMsg(resp.state);

            if (err_msg != '')
            {
                if (_pri.$win_ss !== null && typeof _pri.$win_ss === 'object')
                {
                    var $tgt = _pri.$win_ss.find('.main-body').empty();
                    var $msg = $('<div class="mdl-sct alert-danger text-danger px-2x py-3 mb-3"></div>');
                    $msg.html(err_msg);
                    $tgt.append($msg);
                }
                else
                {
                    JW.Modal.showMsg(err_msg, 'Dateiaustausch');
                }
            }
        }
    };

    publ.getErrMsg = function(state)
    {
        return (_pri.err_msgs[state] || '');
    };

    _pri.setErrMsgs = function()
    {
        _pri.err_msgs = {};
        _pri.err_msgs[State.STATE_OK]    = '';
        _pri.err_msgs[State.STATE_ERR_SS_META] = '';
        _pri.err_msgs[State.STATE_ERR_SS_SIZE] = 'Die Datei ist leider zu gross.<br>Die maximale Grösse beträgt 8 MB.';
        _pri.err_msgs[State.STATE_ERR_SS_FROM] = '';
        _pri.err_msgs[State.STATE_ERR_SS_TO]   = 'Der Empfänger ist zwischenzeilich leider nicht mehr erreichbar.';
        _pri.err_msgs[State.STATE_ERR_AUTH]    = 'Bitte loggen Sie sich ein.';
    };

    _pri.onSSBtnSendClick = function(e)
    {
        _pri.dbg('*** _pri.onSSBtnSendClick() clicked ...');

        if (publ.isValidConn())
        {
            var $this   = $(this);
            var file_id = $this.data('file_id');
            var $inp    = $('#ss_inp_file_' + file_id);
            var sid_to  = $this.data('sid_to');

            if ($inp.length > 0 && typeof $inp[0] === 'object' && typeof $inp[0].files !== 'undefined' && typeof $inp[0].files[0] !== 'undefined')
            {
                if (typeof sid_to !== 'undefined' && sid_to != '' && sid_to === $inp.data('sid_to'))
                {
                    _pri.dbg('    oki');

                    var $btn = $this.removeClass('ss_btn_send');
                    var $win = $('#sio_win_user_' + file_id);
                    var $lbl = $('#ss_file_lbl_' + file_id);
                    var $bbg = $win.find('.ss_progress');
                    var $bar = $win.find('.ss_progress_bar');

                    // $btn.prop('disabled', true);
                    // $btn.addClass('op03');
                    $btn.removeClass('btn-primary-l').addClass('btn-danger').text('Abbrechen');
                    $lbl.attr('for', '').text('0%').addClass('text-white');
                    $bbg.removeClass('bg-white');

                    var file = $inp[0].files[0];
                    var stream_w = ss.createStream();

                    // upload a file to the server ...
                    ss(_pri.socket).emit('ss_file', stream_w, {size: file.size, name: $inp[0].files[0].name, sid_from: _pri.socket.id, sid_to: sid_to}, _pri.cbSsFile);

                    // TODO watch out in production ... for tests, we'll use default - slow enough for testing ;-)
                    // 16MB 16777216
                    // 1MB   1048576
                    // 512    524288
                    // 256    262144
                    // 2^16    65536
                    // def     16384

                    // var stream_r = ss.createBlobReadStream(file);
                    var stream_r = ss.createBlobReadStream(file, {highWaterMark: 524288});

                    // _pri.dbg('    stream_r:', stream_r);
                    var size = 0;
                    var progress = 0;
                    var canceled = false;


                    stream_r.on('data', function(chunk) {
                        if (!canceled)
                        {
                            size += chunk.length;
                            progress = Math.floor(size / file.size * 100);
                            console.log(progress + '%'); // -> e.g. '42%'
                            $lbl.text(progress + '%');
                            $bar.css('width', progress + '%');
                        }
                        else
                        {
                            $bar.css('background-color', '#e83e8c');
                        }
                    });

                    stream_r.on('end', function() {
                        _pri.dbg('*** stream_r on end()');
                        $inp.remove();
                        $btn.off();
                        if (!canceled)
                        {
                            $btn.removeClass('btn-danger').addClass('bg-primary-400 text-white').text('Fertig');
                        }

                        setTimeout(function() {
                            $win.find('.mdl-close').trigger('click');
                        }, 500);

                        // // _pri.dbg('typeof _pri.$win_ss', typeof _pri.$win_ss);
                        // if (_pri.$win_ss !== null && typeof _pri.$win_ss === 'object')
                        // {
                        //     _pri.$win_ss.find('.mdl-close').trigger('click');
                        // }
                    });

                    stream_r.on('finished', function() {
                        _pri.dbg('*** stream_r on finished');
                    });

                    stream_r.on('finish', function() {
                        _pri.dbg('*** stream_r on finish');
                    });

                    stream_r.on('close', function() {
                        _pri.dbg('*** stream_r on close()');
                    });

                    stream_r.on('error', function(err) {
                        _pri.dbg('*** stream_r on error - err:', err);
                    });


                    stream_w.on('unpipe', function(src) {
                        _pri.dbg('*** stream_w on unpipe - e:', src);
                    });

                    stream_w.on('end', function(e) {
                        _pri.dbg('*** stream_w on end');
                    });

                    stream_w.on('close', function(e) {
                        _pri.dbg('*** stream_w on close');
                    });

                    stream_w.on('finished', function() {
                        _pri.dbg('*** stream_w on finished');
                    });

                    stream_w.on('finish', function() {
                        _pri.dbg('*** stream_w on finished');
                    });

                    stream_r.pipe(stream_w);

                    // _pri.dbg('stream_r:', stream_r);

                    $btn.off('click').on('click', function() {
                        var err = {}; //new Error();
                        err.remote  = false;
                        err.message = 'sender canceled';
                        err.dsc = 'description';
                        err.eid = 16638;

                        // stream_r.emit('error', err);
                        stream_w.emit('error', err);
                        canceled = true;
                        // stream_r.unpipe();
                    });
                }
            }
        }
    };

    publ.startSS = function(room_id, sid_to, to_user_name)
    {
        // _pri.dbgG('*** startSS() room_id:', room_id);

        var file_id = _pri.page.getUId();

        _pri.dbg('*** user clicked ...');
        if (_pri.socket.id == sid_to)
        {
            //
        }
        else
        {
            var $inp = $('<input type="file" class="d-none ss_inp_file" id="ss_inp_file_' + file_id + '" data-sid_to="' + sid_to + '" data-file_id="' + file_id + '" data-room_id="' + room_id + '">');
            $inp.on('change', _pri.onSSInpFileChange);
            _pri.$wrp_ss_inp_file.append($inp);

            var tpl = publ.getTpl('sio_win_user');
            var win = tpl.replace(/\{TO_USER_NAME\}/g, to_user_name)
                                            .replace(/\{SID_TO\}/g, sid_to)
                                            .replace(/\{FILE_ID\}/g, file_id)
                                            .replace(/\{ROOM_ID\}/g, room_id)
                                            ;

            _pri.win_id = 'sio_win_user_' + file_id;
            _pri.$win_ss = $(win).attr('id', _pri.win_id).data('file_id', file_id);
            _pri.$win_ss.find('.ss_btn_send').on('click', _pri.onSSBtnSendClick);
            JW.Modal.showMsgWin(_pri.$win_ss, _pri.win_id);

        }
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.addRoom = function(meta)
    {
        _pri.dbg('*** addRoom(' + meta.room_id_to + ')');

        if (typeof _pri.rooms_map[meta.room_id_to] === 'undefined')
        {
            var room = JW.SiocLiveRoom(jQuery, publ, _pri.socket, meta);
            _pri.rooms_map[meta.room_id_to] = room;
        }
        else
        {
            _pri.dbg('    !!! room [' + room_id + '] already exists!');
        }
    };

    _pri.initRooms = function()
    {
        if (!_pri.rooms_inited)
        {
            _pri.rooms_inited = true;

            var room_ids_str = _pri.$wrp_sioc.data('init_rooms');
            var meta;
            // _pri.dbg('1', room_ids_str, typeof room_ids_str);
            if (typeof room_ids_str === 'string')
            {
                room_ids_str.split(',').map(function(v) {
                    v = v.trim();
                    if (v != '')
                    {
                        _pri.dbg('    v:', v);
                        meta = publ.getMeta();
                        meta.room_id_to = v;
                        meta.display_name = 'Messebesucher'; //XXX get it from data filled by session ...
                        _pri.addRoom(meta);
                    }
                });
            }
        }
    };

    _pri.getRoomByMeta = function(meta)
    {
        if (typeof meta === 'object' && typeof meta.room_id === 'string' && typeof _pri.rooms_map[meta.room_id] !== 'undefined')
        {
            // _pri.dbg('*** getRoomByMeta() typeof _pri.rooms_map[meta.room_id]', typeof _pri.rooms_map[meta.room_id]);
            return _pri.rooms_map[meta.room_id];
        }
        return null;
    };

    _pri.initEvs = function()
    {
        _pri.page.on('modal:logged_in', function(e, o) {

            _pri.dbg('on modal:logged_in o: ', o);

            if (publ.isConn())
            {
                _pri.socket.emit('check_login');
            }
            else
            {
                _pri.connect();
            }
        });

        _pri.page.on('modal:close_win', function(e, o) {

            _pri.dbg('on modal:close_win o: ', o);
            if (typeof o === 'object' && typeof o.win !== 'undefined' && o.win == _pri.win_id)
            {
                _pri.dbg('    ok, that\'s mine ...');
                _pri.$win_ss = null;
            }
        });
    };


    _pri.extend();
    // expose public methods
    return publ;
})(jQuery);
